module.exports = __webpack_public_path__ + "img/mobile-tv.16b390c4.svg";